const makeValue = <T>(value: T | (() => T)) => (typeof value === 'function' ? (value as Function)() : value);

export default makeValue;
